export const QUICKBET_MODAL_ID = 'modalQuickbet'
